import { Component, HostListener, OnInit, OnDestroy, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../services/web.service';
import { FooterComponent } from '../footer/footer.component';
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';

import { MetaTagService } from '../meta-tag.service';
@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [HeaderComponent,CommonModule, FooterComponent, HttpClientModule,RouterModule, IconsFreeToolsComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent {
  constructor( private metaTagService: MetaTagService){}

  ngOnInit(): void {
    this.metaTagService.updateTags("Privacy Policy | Grammarin.com", "Learn how we collect, use, and protect your personal information. Your privacy is our top priority!", "https://www.grammarin.com/privacy-policy");
  }


  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
